import React, {Component} from "react";
import {buttonpanelAssetConfig} from "../../../data/buttonpanel"


import {Ibutton, objectTypes} from "../interface/Ibuttons";
import {Icomponent} from "../../commongame/interface/Icomponent";

interface IframeworkButtonPanel {
    data: {

        alwaysEnableButtonNameList: any,
        COMPONENTS: any
        COREBUTTONPANEL: any
    }

}

export const frameworkButtonPanel: IframeworkButtonPanel = {
    data: {
        alwaysEnableButtonNameList: [],
        COREBUTTONPANEL: [],
        COMPONENTS: []
    }


};

export const ButtonPanelConfigurationContext = React.createContext(
    {}
);